const germanGrammar = [
  {
    id: 'tenses',
    name: 'Tenses',
    subcategories: [
      {
        id: 'present',
        name: 'Present',
      },
      {
        id: 'present-perfect',
        name: 'Present Perfect',
      },
      {
        id: 'simple-past',
        name: 'Simple Past',
      },
      {
        id: 'past-perfect',
        name: 'Past Perfect',
      },
      {
        id: 'future',
        name: 'Future',
      },
      {
        id: 'future-perfect',
        name: 'Future Perfect',
      },
    ],
  },
  {
    id: 'nouns-and-articles',
    name: 'Nouns and Articles',
  },
  {
    id: 'verbs',
    name: 'Verbs',
  },
  {
    id: 'adjectives',
    name: 'Adjectives',
  },
  {
    id: 'pronouns',
    name: 'Pronouns',
  },
  {
    id: 'adverbs',
    name: 'Adverbs',
  },
  {
    id: 'prepositions',
    name: 'Prepositions',
  },
]

export default germanGrammar



// WEBPACK FOOTER //
// ./src/browser/grammar/languages/german/rulesList.js